"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5961],{

/***/ 25961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CaregiverCardFull": function() { return /* binding */ CaregiverCardFull; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69417);
/* harmony import */ var _components_feature_searchDirectory_LatestReview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29460);
/* harmony import */ var _CaregiverOverview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89299);
/* harmony import */ var _CaregiverExperienceSummary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92773);
/* harmony import */ var _CaregiverServices__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76341);






var CaregiverCardFull = function(param) {
    var searchResult = param.searchResult;
    var ref, ref1;
    var caregiver = searchResult.caregiver;
    var bio = (ref = caregiver.profiles) === null || ref === void 0 ? void 0 : (ref1 = ref.commonCaregiverProfile) === null || ref1 === void 0 ? void 0 : ref1.bio;
    var _aiAssistedBio;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        width: "100%",
        p: 3,
        borderRadius: 6,
        sx: {
            mt: 4,
            "&:first-of-type": {
                mt: 0
            }
        },
        bgcolor: "background.primary",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CaregiverOverview__WEBPACK_IMPORTED_MODULE_2__/* .CaregiverOverview */ .y, {
                searchResult: searchResult
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                display: "flex",
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CaregiverServices__WEBPACK_IMPORTED_MODULE_4__/* .CaregiverServices */ .t, {
                                sx: {
                                    mt: 3
                                },
                                caregiver: searchResult.caregiver
                            }),
                            (bio === null || bio === void 0 ? void 0 : bio.experienceSummary) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CaregiverExperienceSummary__WEBPACK_IMPORTED_MODULE_3__/* .CaregiverExperienceSummary */ .N, {
                                sx: {
                                    mt: {
                                        sm: 3
                                    }
                                },
                                experienceSummary: bio.experienceSummary,
                                isAIAssistedBio: (_aiAssistedBio = bio.aiAssistedBio) !== null && _aiAssistedBio !== void 0 ? _aiAssistedBio : false
                            }),
                            searchResult.latestReview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_feature_searchDirectory_LatestReview__WEBPACK_IMPORTED_MODULE_1__/* .LatestReview */ .f, {
                                    latestReview: searchResult.latestReview
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: searchResult.profileURL,
                        target: "_blank",
                        size: "medium",
                        sx: {
                            minWidth: "160px",
                            ml: 4,
                            alignSelf: "flex-end"
                        },
                        color: "primary",
                        variant: "contained",
                        children: "See\xa0profile"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CaregiverCardFull);


/***/ })

}]);